import { call, put, takeLatest, delay } from "redux-saga/effects";
import {
    getPeriods,
    getCourses,
    getScheme,    
    saveScheme,
    generateScheme,
    regenerateScheme,
    getSchemePDF,
    fetchSchemeStatus
} from "../../api/teacher";
import { teacherActions } from "./teacherSlice";
import { toast } from "@helps/toast";


const {
    periodsStart,
    coursesStart,
    schemeStart,
    saveSchemeStart,
    saveChangeStart,
    setPeriods,
    setSchemeId,
    setCourses,
    setScheme,  
    setSchemeNode,  
    setUpdate,
    generateSchemeStart,
    regenerateSchemeStart,
    toggleLoading,
    schemePDFStart,
} = teacherActions;

export function* teacherWatcher() {
    yield takeLatest(periodsStart.type, setPeriodsWorker);
    yield takeLatest(coursesStart.type, setCoursesWorker);
    yield takeLatest(schemeStart.type, setSchemeWorker);
    yield takeLatest(generateSchemeStart.type, generateSchemeWorker);
    yield takeLatest(regenerateSchemeStart.type, regenerateSchemeWorker);
    yield takeLatest(saveSchemeStart.type, saveSchemeWorker);
    yield takeLatest(saveChangeStart.type, changeSchemeWorker);
    yield takeLatest(schemePDFStart.type, getSchemePDFWorker);
}

function* setPeriodsWorker() {
    yield put(toggleLoading(true));
    try {
        const response = yield call(getPeriods);
        yield put(setPeriods(response.data));
    } catch (error) {
        yield console.log("что-то пошло не так", error);
    } finally {
        yield put(toggleLoading(false));
    }
}

function* getSchemePDFWorker(action) {
    console.log("PDF Request", action.payload.schemeId)
    const courseId = action.payload.schemeId
    window.open("https://alesha.edumil.ru/api/courses/"+courseId+"/schemes/pdf", '_blank');
    /*try {
        let response = yield call(getSchemePDF, courseId);

        if (response.status === 200) {
            console.log(response)
            const buffer = new ArrayBuffer(response.data.length);
            const view = new Uint8Array(buffer);
            for (let i = 0; i < response.data.length; i++) {
                view[i] = response.data.charCodeAt(i) & 0xff;
            }
            console.log(buffer)
            const file = new Blob([buffer], { type: "application/pdf" });
            //Build a URL from the file
            const fileURL = URL.createObjectURL(file);
            //Open the URL on new Window
            const pdfWindow = window.open('', '_blank');
            setTimeout(() => {
                pdfWindow.location.href = fileURL;
            }, 500);
        }
        else {
            yield alert("Ошибка");
        }
    }
    catch {
        yield alert("Ошибка");
    }*/
}


function* setCoursesWorker(action) {
    const yearId = action.payload;
    yield put(toggleLoading(true));
    const response = yield call(getCourses, yearId);
    yield put(setCourses(response.data));
    yield put(toggleLoading(false));
}

function* setSchemeWorker(action) {
    try {
        const courseId = action.payload;
        yield put(toggleLoading(true));
        const response = yield call(getScheme, courseId);
        if (response.status === 200) {
            yield put(setScheme(response.data));
            yield put(setSchemeId(courseId))
        }
    } catch (error) {
        yield console.log("что-то пошло не так", error)
    } finally {
        yield put(toggleLoading(false));
    }
}


function* generateSchemeWorker(action) {
    try {
        const courseId = action.payload.schemeId;

        yield put(toggleLoading(true));

        // 🔹 Первый вызов: запускаем генерацию
        const response = yield call(generateScheme, courseId, action.payload);

        if (response.status !== 200) {
            yield call(toast.error, "Что-то пошло не так");
            return;
        }

        const { status } = response.data;

        if (status === "ошибка") {
            yield call(toast.error, "Ошибка генерация урока с помощью ИИ. Пожалуйста, Попробуйте еще раз.");
            return;
        }

        if (status === "завершенный") {
            yield put(setScheme(response.data));
            yield put(setSchemeId(courseId));
            yield call(toast.success, "Генерация урока с помощью ИИ завершена.");
            return;
        }

        // 🔹 Статус = обработка → показать заглушку
        if (status === "обработка") {
            const obr = {
                scheme: [
                    {
                        id: "1",
                        data: {},
                        type: "start",
                        position: { x: 120, y: 120 }
                    },
                    {
                        id: "2",
                        data: {
                            text: "Генерация в процессе. Нажмите «GPT-генерация», чтобы обновить статус.",
                            images: [],
                            videos: [],
                            audios: []
                        },
                        type: "text",
                        position: { x: 180, y: 220 }
                    },
                    {
                        id: "in_1_out_2",
                        source: "1",
                        sourceHandle: "out",
                        target: "2",
                        targetHandle: "in",
                        type: "customedge",
                        data: {}
                    }
                ]
            };
            yield put(setScheme(obr));
            yield put(setSchemeId(courseId));
        }

        // 🔁 Начинаем опрос статуса
        let polling = true;
        while (polling) {
            yield delay(2000); // 2 сек

            // 🔸 Здесь используем getScheme — для получения текущего статуса!
            const statusResponse = yield call(fetchSchemeStatus, courseId);

            if (statusResponse.status !== 200) {
                yield call(toast.error, "Ошибка при проверке статуса.");
                break;
            }

            const currentStatus = statusResponse.data.status;

            if (currentStatus === "завершенный") {
                yield put(setScheme(statusResponse.data));
                yield put(setSchemeId(courseId));
                yield call(toast.success, "Генерация урока с помощью ИИ завершена.");
                polling = false;
            } else if (currentStatus === "ошибка") {
                yield call(toast.error, "Ошибка генерации. Попробуйте ещё раз.");
                polling = false;
            }
        }

    } catch (error) {
        console.error("Что-то пошло не так", error);
    } finally {
        yield put(toggleLoading(false));
    }
}


function* regenerateSchemeWorker(action) {    
    try {        
        let courseId = action.payload.schemeId;
                
        if (courseId==null)
            courseId = 0;       
        yield put(toggleLoading(true));        
        
        
        let response = yield call(regenerateScheme, courseId, action.payload);	
        
        const update = { "id":courseId , "data": response.data, "oldscheme": [...action.payload.regenerate.scheme.scheme]}	        
        //let mockdata = { "oldText": action.payload.regenerate.data.text,  "scheme": { "data": { "text": "TST " + Date.now() + " " + action.payload.reason, "oldText": action.payload.regenerate.data.text} , "id": courseId}}            
        //if(action.payload.type === "image")
        //   mockdata = { "oldText": action.payload.regenerate.data.text,  "url": "bla"+ Date.now()+".jpg"}    
        //const zupdate = { "id":courseId , "data": mockdata, "oldscheme": [...action.payload.regenerate.scheme.scheme]}	
        //console.log("UPDATE_GOT_UPDATE", update)
        //console.log("UPDATE_GOT_ZUPDATE", zupdate)
        yield put(setUpdate(update))        
        yield put(setSchemeNode(update))	
        
        
    } catch (error) {
        yield console.log("что-то пошло не так", error)
    } finally {
        yield put(toggleLoading(false));
    }
}


function* changeSchemeWorker(action) {
    const newScheme = action.payload;
    yield put(setScheme(newScheme));
}

function* saveSchemeWorker(action) {
    const { data, schemeId } = action.payload;
    try {
        yield put(toggleLoading(true));
        const response = yield call(saveScheme, { data, schemeId });
        yield put(setScheme(response.data))
        yield put(toggleLoading(false));
        yield call(toast.success, "Урок успешно сохранен");
    } catch (error) {
        yield call(toast.error, "что-то пошло не так");        
        yield put(toggleLoading(false));
    }
}